import React from 'react'
import PropTypes from 'prop-types'
import { Alert, Panel, ProgressBar, Table } from 'react-bootstrap'

import { getBarStyle, client } from '../../utils'
import { dashboard as endpoints } from '../../api_urls'
import { LoadingSpinner } from '../../components'

class AssessmentPerformance extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      topTen: [],
      bottomTen: [],
      loading: true,
      error: false,
    }
  }

  static propTypes = {
    coursenum: PropTypes.string.isRequired,
    flexDirection: PropTypes.string.isRequired,
  }

  componentDidMount() {
    this.fetchData()
    this.fetchData(false)
  }

  async fetchData(top = true) {
    let stateKey = top ? 'topTen' : 'bottomTen'
    let url = `${endpoints.getAssessmentAnalyticsURL()}?record_num=10&top=${top.toString()}`
    try {
      var response = await client.get(url)
    } catch (err) {
      console.error(`Error fetching ${url}`, err)
      return this.setState({ loading: false, error: true })
    }
    this.setState({
      [stateKey]: response.data.ordered_assessments,
      loading: false,
    })
  }

  renderRows = dataList => {
    if (this.state.error) {
      return (
        <tr>
          <td colSpan="2">
            <Alert bsStyle="warning" className="text-center">
              Content failed to load
            </Alert>
          </td>
        </tr>
      )
    } else {
      return dataList.map(elem => (
        <tr key={elem['activity__pk']}>
          <td>
            <a
              href={`/instructor/assessment/${this.props.coursenum}/${elem['activity__pk']}`}
            >
              {elem['title']}
            </a>
          </td>
          <td>
            <ProgressBar
              now={elem['mean_pct']}
              label={`${Math.round(elem['mean_pct'])}%`}
              bsStyle={getBarStyle(elem['mean_pct'])}
            />
          </td>
        </tr>
      ))
    }
  }

  renderLoadingRows = () => {
    return (
      <tr className="text-center">
        <td colSpan="2">
          <LoadingSpinner />
        </td>
      </tr>
    )
  }

  render() {
    let topRows = this.state.loading
      ? this.renderLoadingRows()
      : this.renderRows(this.state.topTen)
    let bottomRows = this.state.loading
      ? this.renderLoadingRows()
      : this.renderRows(this.state.bottomTen)
    return (
      <div style={{ display: 'flex', flexDirection: this.props.flexDirection }}>
        <div style={{ flexGrow: 1, margin: '10px' }}>
          <h4> Worst Performing Assessments</h4>
          <Panel>
            <Table responsive>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Avg. Score</th>
                </tr>
              </thead>
              <tbody>{bottomRows}</tbody>
            </Table>
          </Panel>
        </div>
        <div style={{ flexGrow: 1, margin: '10px' }}>
          <h4> Best Performing Assessments</h4>
          <Panel>
            <Table responsive>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Avg. Score</th>
                </tr>
              </thead>
              <tbody>{topRows}</tbody>
            </Table>
          </Panel>
        </div>
      </div>
    )
  }
}

export default AssessmentPerformance
